import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M24 20.993V24H0v-2.996A14.98 14.98 0 0 1 12.004 15c4.904 0 9.26 2.354 11.996 5.993M16.002 8.999a4 4 0 1 1-8 0 4 4 0 0 1 8 0" }, null, -1)
  ])))
}
export default { render: render }